import lozad from 'lozad';
import functions from '../functions';
import Slider from '../components/Slider';
import { list } from './list';

$(() => {
    listAjax.init();
});

const listAjax = {
    $listItems: null,
    _defaults: {
        _page: 1,
        perPage: 12,
        sortBy: '',
        language: functions.getLang(),
        template: 'featured',
        transportationType: null,
        paginate: 1,
        partner: null,
        exclude: null,
        excludeAccCountryIds: null
    },
    init() {
        this.$listItems = $('.list-featured');

        if (! this.$listItems.length) return;

        this.cardSkeleton = `<div class="col-xl-4 col-md-4 col-sm-6 col-11 skeleton-col">
            <a class="card ard-accommodation card-featured card-package">
                <div class="card-img-top bg-light"></div> 
                <div class="card-body" style="height:185px;">
                    <div>
                        <div class="title h4 text-dark bg-light rounded mt-1 px-1" style="height:27px; width:125px;"></div>
                    </div>
                    <div class="bg-light rounded" style="height: 65px;"></div>
                </div>
             </a>
        </div>`;
        this.listSkeleton = `<div class="row gx-4 list-skeleton">` + this.cardSkeleton.repeat(3) + `</div>`;
        const observerVillas = lozad('.list-featured', {
            rootMargin: '200px 200px',
            loaded: el => {
                let elem = this.$listItems = $(el);
                // if ( !this.$listItems.attr('data-loaded') ) {
                    let params = this.setDefaults(elem);
                    params = this.getParams(params);
                    this.find(params, elem);
                // }
                
                $(el).triggerHandler('lozadLoaded');
            }
        });
        observerVillas.observe();
    },
    setDefaults(currItem = null) {
        let currentList = currItem || this.$listItems;
        let params = {};
        params.dynamicPackage = currentList.attr('data-dynamicpackage');
        params.countryId = currentList.attr('data-countryid');
        params.destination = currentList.attr('data-destination');
        params.objectGroupId = currentList.attr('data-objectgroupid');
        params.objectTypeId = currentList.attr('data-objecttypeid');
        params.tagCategoryId = currentList.attr('data-tagcategoryid');
        params.tagCategoryIds = currentList.attr('data-tagcategoryids');
        params.catalogueId = currentList.attr('data-catalogueId');
        params.transportationType = currentList.attr('data-transportationtype') || this._defaults.transportationType;
        params.template = currentList.attr('data-template') || this._defaults.template;
        params.perPage = currentList.attr('data-perPage') || this._defaults.perPage;
        params.sortBy = currentList.attr('data-sortBy') || this._defaults.sortBy;
        params.paginate = currentList.attr('data-paginate') || this._defaults.paginate;
        params.partner = currentList.attr('data-partner') || this._defaults.partner;
        params.exclude = currentList.attr('data-exclude') || this._defaults.exclude;
        params.hasArrival = currentList.attr('data-hasarrival') || this._defaults.exclude;
        params.dateFrom = currentList.attr('data-datefrom') || this._defaults.exclude;
        params.dateTo = currentList.attr('data-dateto') || this._defaults.exclude;
        params.arrivalDateFrom = currentList.attr('data-arrivaldatefrom') || this._defaults.exclude;
        params.arrivalDteTo = currentList.attr('data-arrivaldateto') || this._defaults.exclude;
        params.excludeAccCountryIds = currentList.attr('data-excludeAccCountryIds') || this._defaults.exclude;

        if ($('form.search-form').attr('data-excludecountryids'))
        {
            params.excludeCountryIds = JSON.parse($('form.search-form').attr('data-excludecountryids'));
        }

        return params;
    },
    getParams(params) {
        return list.getParams(this.params, params);
    },
    find(params, currItem = null) {
        this.setLoadingMode(currItem);
        this.params = params;
        this.params.ajax = 1;

        $.get('/services/list/', params).then((response) => {
            this.findDone(response, currItem);

            $('.departure').on('click', e => {
                e.preventDefault(currItem);

                const $target = $(e.currentTarget);
                let href = $target.attr('data-href');
                href = href.split('#')[0];

                const dateFrom = $target.attr('data-datefrom');
                const dateTo = $target.attr('data-dateto');

                href += '#dateFrom=' + dateFrom + '&dateTo=' + dateTo;
                //location = href; 
                window.open(href, '_blank');
            });

        });
    },
    findDone(response, currItem = null) {
        response = JSON.parse(response);

        this.unsetLoadingMode(currItem);

        this.total = response.total;
        let currentList = currItem || this.$listItems;
        currentList.html(response.html).attr('data-loaded', 1);
        
        this.initComponents();

    },
    setLoadingMode(currItem = null) {
        let item = currItem || this.$listItems;

        item.html(this.listSkeleton);
        // debugger;
        // if(! this.loading) {
            // this.loading = true;

            // if ( ! item.find('.spinner').length) {
            //     $('<div class="spinner d-flex justify-content-center my-5 py-5"><div class="spinner-border text-secondary" role="status" style="width: 4rem; height: 4rem;"><span class="sr-only">Loading...</span></div></div>')
            //     .insertBefore(item);
            // }

            // item.addClass('d-none');
        // }
    },
    unsetLoadingMode(currItem = null) {
        let item = currItem || this.$listItems;
        // if(this.loading) {
            // this.loading = false;

            // item.prev().remove();
            // item.removeClass('d-none');

            //functions.scrollToElement(this.$listItems, 100);
        // }
    },
    initComponents() {

        // LOZAD
        window.observer = lozad('.lozad', {
            rootMargin: '200px 0px',
            loaded: el => {
                $(el).triggerHandler('lozadLoaded');
            }
        });
        window.observer.observe();

        // register paginate        
        $('[data-page]').on('click', e => {
            e.preventDefault();
            this.paginate(+$(e.currentTarget).attr('data-page'));
        });

        const isMobile = functions.isMobile();

        let listSlider = [];
        $('[id^=list-slider]').each((i, elem) => {
            const length = $(elem).find('.keen-slider__slide').length;
    
            listSlider[i] = new Slider('#' + $(elem).attr('id'), {
                rubberband: false,
                loop: true,
                arrows: true,
                spacing: 0,
                pager: true,
                drag: isMobile,
                slides: {
                perView: 3,
                spacing: 0
                },
                breakpoints: {
                    '(max-width: 1360px)': {
                        origin: 'center',
                        drag: true,
                        loop: true,
                        slides: {
                            perView: 3,
                            spacing: 0,
                        },
                    },
                    '(max-width: 991px)': {
                        origin: 'center',
                        drag: true,
                        loop: true,
                        slides: {
                            perView: 2.2,
                            spacing: 0,
                        },
                    },
                    '(max-width: 767px)': {
                        origin: 'center',
                        drag: true,
                        loop: true,
                        slides: {
                            perView: 1.1,
                            spacing: 0,
                        },
                    },
                },
            });
    
            const $arrows = $(elem).siblings('.keen-slider__arrows');
    
            if (isMobile && length < 2) {
                $arrows.addClass('d-none');
            } else if (! isMobile && length < 3) {
                $arrows.addClass('d-none');
            } else {
                $arrows.removeClass('d-none');
            }
    
        });

    },
    paginate(page) {
        if (page != this.params._page) {
            this.params._page = page;
        }

        functions.setUrlData(this.params, true, false, this.defaults);
    },
};